import { ChevronLeft, ChevronRight } from "lucide-react";
import { Button } from "../../../../components/ui/button";

export function Pagination({ data, onChange, label }) {
  const { page, totalPages, total, limit } = data;
  const first = total === 0 ? 0 : (page - 1) * limit + 1;
  const last = Math.min(total, page * limit);

  return (
    <div className="flex items-center justify-between px-5 py-3 text-xs text-muted-foreground">
      <span>
        {total === 0 ? (
          "No results"
        ) : (
          <>
            <span className="font-mono text-foreground">{first}</span>
            <span className="mx-1">–</span>
            <span className="font-mono text-foreground">{last}</span>
            <span className="mx-2">of</span>
            <span className="font-mono text-foreground">{total}</span>
            {label ? <span className="ml-1">{label}</span> : null}
          </>
        )}
      </span>
      <div className="flex items-center gap-1.5">
        <Button
          variant="outline"
          size="icon"
          disabled={page <= 1}
          onClick={() => onChange(page - 1)}
        >
          <ChevronLeft className="h-3.5 w-3.5" />
        </Button>
        <span className="min-w-[60px] text-center font-mono">
          {page} / {Math.max(1, totalPages)}
        </span>
        <Button
          variant="outline"
          size="icon"
          disabled={page >= totalPages}
          onClick={() => onChange(page + 1)}
        >
          <ChevronRight className="h-3.5 w-3.5" />
        </Button>
      </div>
    </div>
  );
}
